module.exports = __webpack_public_path__ + "static/img/mk.ed091b88.svg";